// back-up feature flag value if firebase failed to initialize on page load
// values should be what to expect in production
export const flags = {
  PAGE_STATION_ACCOUNT: false,
  PAGE_KYC_SUBMISSIONS: true,
};
